/* eslint-disable react/prop-types */
import React, { useState, useEffect, MouseEvent } from "react";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from '@mui/material/FormGroup';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
import Tracking_History from "../tracking_history";
import { getPackages, deletePackage } from "network/service";
import { getPackageHistory } from "network/service";


// Material Dashboard 2 React Components
function DeleteDialog(props) {
    const [notiDetails, setShowDetails] = useState({ show: false });
    const [status, setStatus] = useState(props.details.status);
    const [loading, setLoading] = useState(false);
    const [tracks, setTracks] = useState([]);
  




    const closeSB = () => setShowDetails({ ...notiDetails, show: false });

    const handleChange = (event) => {
        console.log(event);
        switch (event.target.name) {

        }
    };


    function isNumeric(value) {
        return /^\d+$/.test(value);
    }


    const renderSB = (
        <MDSnackbar
            color={notiDetails.color}
            icon={notiDetails.icon}
            title={notiDetails.title}
            content={notiDetails.message}
            dateTime=""
            open={notiDetails.show}
            onClose={closeSB}
            close={closeSB}
            bgWhite
        />
    );




    return (
        < Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose} >
            <DialogContent style={{ width: 700, height: 'auto' }}>
                <FormGroup>
                    <MDBox component="form" noValidate width="100%">
                        <MDTypography
                            color="dark"
                        >
                           {
                           "Do you want to delete this parcel...?"
                           }

                        </MDTypography>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end", marginTop: 20 }}
                        >
                            <MDButton variant="gradient" color="success" style={{ margin: 5 }}
                                disabled={loading}
                                onClick={() => {
                                    deletePackage(props.details._id).then((resp) => {
                                        console.log(resp.data);
                                        console.log('Deleting parcel...');
                                        props.handleclose(true);
                                        window.location.reload()
                                    }).catch((err) => {
                                        console.log(err);
                                        props.handleclose(true);
                                       
                                    });
                                }}>
                                {/* <Icon sx={{ fontWeight: "bold" }}>add</Icon> */}
                                &nbsp;Yes
                            </MDButton>
                            <MDButton variant="gradient" color="error" style={{ margin: 5 }}
                                disabled={loading}
                                onClick={() => {
                                   props.handleclose(true);
                                   
                                }}>
                                {/* <Icon sx={{ fontWeight: "bold" }}>add</Icon> */}
                                &nbsp;No
                            </MDButton>
                        </Grid>

                        {renderSB}
                    </MDBox>
                </FormGroup>
            </DialogContent>
        </Dialog >
    )
};

export default DeleteDialog;